export enum ScheduleType {
    FULL = 0,
    PARTIAL = 1
}